export type InfoSection = { title: string; body: string };

function section(title: string, body: string): InfoSection {
  return { title, body };
}

export const DE: InfoSection[] = [
  section(
    'Datenschutzerklärung',
    `Allgemeine Hinweise

Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie unsere Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.

Wer ist verantwortlich für die Datenerfassung auf dieser Website?

Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.

Wie erfassen wir Ihre Daten?

Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben.

Andere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie unsere Website betreten.

Wofür nutzen wir Ihre Daten?

Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.

Welche Rechte haben Sie bezüglich Ihrer Daten?

Sie haben jederzeit das Recht unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung, Sperrung oder Löschung dieser Daten zu verlangen. Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.

Analyse-Tools und Tools von Drittanbietern

Beim Besuch unserer Website kann Ihr Surf-Verhalten statistisch ausgewertet werden. Das geschieht vor allem mit Cookies und mit sogenannten Analyseprogrammen. Die Analyse Ihres Surf-Verhaltens erfolgt in der Regel anonym; das Surf-Verhalten kann nicht zu Ihnen zurückverfolgt werden. Sie können dieser Analyse widersprechen oder sie durch die Nichtbenutzung bestimmter Tools verhindern. Detaillierte Informationen dazu finden Sie in der folgenden Datenschutzerklärung.

Sie können dieser Analyse widersprechen. Über die Widerspruchsmöglichkeiten werden wir Sie in dieser Datenschutzerklärung informieren

Datenschutz

Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.

Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können. Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht.

Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.

Hinweis zur verantwortlichen Stelle

Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:

Niko Holm Stage N Lindenweg 16 33129 Delbrück

Telefon: 0 52 51 / 70 91 922 E-Mail: anfrage@stage-n.de

Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, E-Mail-Adressen o. Ä.) entscheidet.

Widerruf Ihrer Einwilligung zur Datenverarbeitung

Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.

Beschwerderecht bei der zuständigen Aufsichtsbehörde

Im Falle datenschutzrechtlicher Verstöße steht dem Betroffenen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu. Zuständige Aufsichtsbehörde in datenschutzrechtlichen Fragen ist der Landesdatenschutzbeauftragte des Bundeslandes, in dem unser Unternehmen seinen Sitz hat. Eine Liste der Datenschutzbeauftragten sowie deren Kontaktdaten können folgendem Link entnommen werden: https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html.

Recht auf Datenübertragbarkeit

Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen, maschinenlesbaren Format aushändigen zu lassen. Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.

SSL- bzw. TLS-Verschlüsselung

Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL-bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von "http://" auf "https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.

Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen werden.

Auskunft, Sperrung, Löschung

Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden.

Widerspruch gegen Werbe-Mails

Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit widersprochen. Die Betreiber der Seiten behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-E-Mails, vor.

Cookies

Die Internetseiten verwenden teilweise so genannte Cookies. Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Cookies sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr Browser speichert.

Die meisten der von uns verwendeten Cookies sind so genannte "Session-Cookies". Sie werden nach Ende Ihres Besuchs automatisch gelöscht. Andere Cookies bleiben auf Ihrem Endgerät gespeichert bis Sie diese löschen. Diese Cookies ermöglichen es uns, Ihren Browser beim nächsten Besuch wiederzuerkennen.

Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browser aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalität dieser Website eingeschränkt sein.

Cookies, die zur Durchführung des elektronischen Kommunikationsvorgangs oder zur Bereitstellung bestimmter, von Ihnen erwünschter Funktionen (z.B. Warenkorbfunktion) erforderlich sind, werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert. Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von Cookies zur technisch fehlerfreien und optimierten Bereitstellung seiner Dienste. Soweit andere Cookies (z.B. Cookies zur Analyse Ihres Surfverhaltens) gespeichert werden, werden diese in dieser Datenschutzerklärung gesondert behandelt.

Server-Log-Dateien

Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind: Browsertyp und Browserversion, verwendetes Betriebssystem, Referrer URL, Hostname des zugreifenden Rechners, Uhrzeit der Serveranfrage, IP-Adresse. Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Grundlage für die Datenverarbeitung ist Art. 6 Abs. 1 lit. f DSGVO, der die Verarbeitung von Daten zur Erfüllung eines Vertrags oder vorvertraglicher Maßnahmen gestattet.

Kontaktformular

Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter. Die Verarbeitung der in das Kontaktformular eingegebenen Daten erfolgt somit ausschließlich auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Sie können diese Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitungsvorgänge bleibt vom Widerruf unberührt. Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt (z.B. nach abgeschlossener Bearbeitung Ihrer Anfrage). Zwingende gesetzliche Bestimmungen – insbesondere Aufbewahrungsfristen – bleiben unberührt.

Verarbeiten von Daten (Kunden- und Vertragsdaten)

Wir erheben, verarbeiten und nutzen personenbezogene Daten nur, soweit sie für die Begründung, inhaltliche Ausgestaltung oder Änderung des Rechtsverhältnisses erforderlich sind (Bestandsdaten). Dies erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO. Personenbezogene Daten über die Inanspruchnahme unserer Internetseiten (Nutzungsdaten) erheben, verarbeiten und nutzen wir nur, soweit dies erforderlich ist, um dem Nutzer die Inanspruchnahme des Dienstes zu ermöglichen oder abzurechnen. Die erhobenen Kundendaten werden nach Abschluss des Auftrags oder Beendigung der Geschäftsbeziehung gelöscht. Gesetzliche Aufbewahrungsfristen bleiben unberührt.

Datenübermittlung bei Vertragsschluss für Online-Shops, Händler und Warenversand

Wir übermitteln personenbezogene Daten an Dritte nur dann, wenn dies im Rahmen der Vertragsabwicklung notwendig ist, etwa an die mit der Lieferung der Ware betrauten Unternehmen oder das mit der Zahlungsabwicklung beauftragte Kreditinstitut. Eine weitergehende Übermittlung der Daten erfolgt nicht bzw. nur dann, wenn Sie der Übermittlung ausdrücklich zugestimmt haben. Grundlage für die Datenverarbeitung ist Art. 6 Abs. 1 lit. b DSGVO.

Datenweitergabe an Versanddienstleister

Sofern Sie uns hierzu während oder nach Ihrer Bestellung Ihre ausdrückliche Einwilligung erteilt haben, geben wir aufgrund dieser gemäß Art. 6 Abs. 1 S. 1 lit. a DSGVO Ihre E-Mail-Adresse und Telefonnummer an den ausgewählten Versanddienstleister weiter. DHL Paket GmbH, Sträßchensweg 10, 53113 Bonn.

Einsatz von Google (Universal) Analytics zur Webanalyse

Zur Webseitenanalyse setzt diese Website Google (Universal) Analytics ein. Dies dient der Wahrung unserer im Rahmen einer Interessensabwägung überwiegenden berechtigten Interessen an einer optimierten Darstellung unseres Angebots gemäß Art. 6 Abs. 1 S. 1 lit. f DSGVO. Sie können die Erfassung verhindern, indem Sie das unter http://tools.google.com/dlpage/gaoptout?hl=de verfügbare Browser-Plugin herunterladen und installieren.

Google AdWords Remarketing

Über Google Adwords werben wir für diese Website. Dazu wird bei Besuch unserer Website das sog. Remarketing Cookie von Google gesetzt. Dies dient der Wahrung unserer im Rahmen einer Interessensabwägung überwiegenden berechtigten Interessen an einer optimalen Vermarktung unserer Webseite gemäß Art. 6 Abs. 1 S. 1 lit. f DSGVO.

Verwendung von Social Plugins von Facebook

Auf unserer Website werden sogenannte Social Plugins von sozialen Netzwerken verwendet. Durch die Einbindung der Plugins erhalten die Anbieter die Information, dass Ihr Browser die entsprechende Seite unseres Webauftritts aufgerufen hat. Dies dient der Wahrung unserer im Rahmen einer Interessensabwägung überwiegenden berechtigten Interessen an einer optimalen Vermarktung unseres Angebots gemäß Art. 6 Abs. 1 S. 1 lit. f DSGVO. Weitere Informationen: http://www.facebook.com/policy.php

Youtube Video Plugins

Auf dieser Webseite werden Inhalte von Youtube (Google LLC) eingebunden. Bei Videos von Youtube, die auf unserer Seite eingebunden sind, ist die erweiterte Datenschutzeinstellung aktiviert. Die Einbindung der Videos dient der Wahrung unserer im Rahmen einer Interessensabwägung überwiegenden berechtigten Interessen an einer optimalen Vermarktung unseres Angebots gemäß Art. 6 Abs. 1 S. 1 lit. f DSGVO.

Google Maps

Diese Seite nutzt über eine API den Kartendienst Google Maps. Anbieter ist die Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA. Zur Nutzung der Funktionen von Google Maps ist es notwendig, Ihre IP-Adresse zu speichern. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar. Mehr Informationen: https://www.google.de/intl/de/policies/privacy/

Kontaktmöglichkeiten und Ihre Rechte

Als Betroffener haben Sie folgende Rechte: gemäß Art. 15 DSGVO das Recht auf Auskunft; gemäß Art. 16 DSGVO das Recht auf Berichtigung; gemäß Art. 17 DSGVO das Recht auf Löschung; gemäß Art. 18 DSGVO das Recht auf Einschränkung der Verarbeitung; gemäß Art. 20 DSGVO das Recht auf Datenübertragbarkeit; gemäß Art. 77 DSGVO das Recht, sich bei einer Aufsichtsbehörde zu beschweren. Bei Fragen wenden Sie sich bitte an die Kontaktdaten in unserem Impressum.

Widerspruchsrecht

Soweit wir personenbezogene Daten wie oben erläutert verarbeiten, können Sie dieser Verarbeitung mit Wirkung für die Zukunft widersprechen. Nach Ausübung Ihres Widerspruchsrechts werden wir Ihre personenbezogenen Daten nicht weiter zu diesen Zwecken verarbeiten, es sei denn, wir können zwingende schutzwürdige Gründe für die Verarbeitung nachweisen. Dies gilt nicht, wenn die Verarbeitung zu Zwecken des Direktmarketings erfolgt.`
  ),
  section(
    'Impressum',
    `Tuning Files X
Bilichenko Dmytro
Schulstraße 15
57539 Fürthen
Tel: +49 160 93048497
Email: tuningfilesx@gmail.com
USt-Id-Nr: DE400501016

Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit, die Sie hier finden https://ec.europa.eu/consumers/odr/. Zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle sind wir nicht verpflichtet und nicht bereit.`
  ),
  section(
    'Allgemeine Geschäftsbedingungen (AGB)',
    `1. Allgemeines / Vertragsschluss

Alle Lieferungen und Leistungen erfolgen ausschließlich auf der Grundlage dieser Allgemeinen Geschäftsbedingungen. Unsere Angebote sind freibleibend. Mit der Auftragserteilung werden unsere Liefer- und Zahlungsbedingungen unwiderruflicher Bestandteil des Kaufvertrages. Der Besteller ist vier Wochen an seine Bestellung gebunden. Bei telefonischen oder schriftlichen Aufträgen trägt der Auftraggeber das Risiko und die Kosten. Abweichungen von den nachstehenden Bedingungen sowie Einkaufsbedingungen des Bestellers sind nur dann gültig, wenn sie schriftlich von uns bestätigt werden. Nach Absenden der Bestellung erhält der Besteller eine Eingangsbestätigung, die jedoch keine Auftragsbestätigung darstellt. Der Kaufvertrag kommt entweder durch die Lieferung der bestellten Digitalware oder durch die Übersendung einer Auftragsbestätigung zustande.

1.2 Kundeninformation

Alle am Fahrzeug vorgenommenen Änderungen müssen in den Fahrzeugpapieren eingetragen werden. Bei Nicht-Eintragung können folgende Konsequenzen drohen: Verwaltungsstrafe durch die zuständige Behörde, Verlust des Versicherungsschutzes, Negative Beurteilung bei wiederkehrender Begutachtung, Steuerhinterziehung. Bitte beachten Sie: Die Programmierung des Steuergerätes führt zum Erlöschen der Betriebserlaubnis. Der Betrieb eines Fahrzeugs ohne Betriebserlaubnis im öffentlichen Straßenverkehr führt zum Verlust des Versicherungsschutzes. Der Betrieb eines Fahrzeugs ohne ausreichenden Versicherungsschutz stellt eine Straftat dar. Durch die Programmierung des Steuergerätes (Software-Tuning) entfallen Gewährleistungsansprüche gegenüber dem Verkäufer sowie Garantieansprüche gegenüber dem Hersteller.

1.3 Kundeninformation (Deutschland)

In Deutschland führt Software-Tuning gemäß § 19 Abs. 3 S. 1 Nr. 4 c) StVZO zum Erlöschen der Betriebserlaubnis, wenn die neue Software nicht unverzüglich von einem amtlich anerkannten Sachverständigen abgenommen wird. Der Einbau von Zusatzelektronik (Tuning-Chip) oder Software-Tuning kann dazu führen, dass Gewährleistungs- und Garantieansprüche entfallen.

2. Widerrufsrecht

Unsere Angebote sind unverbindlich. Ein Widerruf ist ausgeschlossen, da die bereitgestellten Dateien keinen Kopierschutz haben.

3. Preise

Es gelten die Preise der zuletzt veröffentlichten Preisliste oder die vereinbarten Preise, zuzüglich der gesetzlichen Mehrwertsteuer am Tag der Lieferung und Leistung.

4. Lieferung

Liefer- und Umbautermine sowie deren Fristen sind unverbindlich. Höhere Gewalt, Betriebs- oder Verkehrsstörungen, Rohstoffmangel, Streik oder ähnliche Umstände entbinden uns von der Einhaltung der Lieferfristen und geben dem Käufer kein Recht auf Schadensersatz oder Vertragsrücktritt.

5. Versand

Der Versand erfolgt digital in Form eines Links innerhalb des Online-Portals.

7. Beanstandungen

Der Käufer hat den Kaufgegenstand bei Erhalt zu prüfen und etwaige Mängel sofort bei Übernahme schriftlich zu melden. Spätere Beanstandungen sind ausgeschlossen, es sei denn, der Käufer weist innerhalb der gesetzlichen Frist nach Übernahme nicht erkennbare Mängel nach. Beanstandungen müssen stets schriftlich unter genauer Angabe der Mängel erfolgen.

8. Gewährleistung / Haftung

Der Käufer muss Fehler unverzüglich schriftlich melden. Nach Feststellung eines Fehlers muss uns unverzüglich Gelegenheit zur Nachbesserung gegeben werden. Wenn der Fehler nicht behoben werden kann oder weitere Nachbesserungen unzumutbar sind, kann der Käufer anstelle der Nachbesserung Rücktritt oder Minderung verlangen. Ein Anspruch auf Ersatzlieferung besteht nicht. Gewährleistungsverpflichtungen bestehen nicht, wenn der Fehler in ursächlichem Zusammenhang damit steht, dass er nicht unverzüglich gemeldet oder Gelegenheit zur Nachbesserung nicht gegeben wurde, die Wartungsvorschriften des Herstellers oder unsere besonderen Betriebs- und Wartungshinweise nicht beachtet wurden, das Fahrzeug überbeansprucht oder im Motorsport eingesetzt wurde. Natürlicher Verschleiß ist von der Gewährleistung ausgeschlossen. Im Falle von Vorsatz oder grober Fahrlässigkeit besteht unbeschränkte Haftung. Bei einfacher, mittlerer oder leichter Fahrlässigkeit beschränkt sich die Haftung auf wesentliche Pflichten des Vertrags.

8.1 Haftung / Gewährleistung für Softwarekunden und Wiederverkäufer

Tuning Files X übernimmt keine Gewährleistung oder Garantie für Fahrzeuge, in denen die Tuning-Software installiert wird. Diese Verantwortung liegt beim Händler. Da unsere Software eine nicht greifbare, unwiderrufliche Ware darstellt, bieten wir keine Rückerstattungen nach dem Kauf. Es liegt in Ihrer Verantwortung sicherzustellen, dass die Software für Ihre Zwecke geeignet ist und Sie über die Fähigkeiten verfügen, sie zu implementieren und zu nutzen. Sie stimmen zu, die Software nicht rechtswidrig zu verwenden. Im Gegenzug für das Recht, die Software zu nutzen, stimmen Sie zu, Tuning Files X eine einmalige, nicht erstattungsfähige Lizenzgebühr zu zahlen.

8.2 Garantie für Wiederverkäufer

Tuning Files X garantiert nicht, dass die Software den Anforderungen des Käufers entspricht, mit anderer Hardware funktioniert oder ohne Unterbrechung oder Fehler arbeitet.

10. Zahlungsbedingungen

Die Zahlung muss vor Lieferung erfolgen und ist per PayPal zu leisten.

11. Werbung

Wir sind berechtigt, in Wort und Bild die Verwendung des Kaufgegenstandes zu veröffentlichen. Eine Werbung im Namen von uns darf nur nach schriftlicher Genehmigung erfolgen.

12. Urheberrechtsschutz

Sämtliche Inhalte des Onlineauftritts unterliegen dem urheberrechtlichen Schutz. Die Inhalte dürfen ohne schriftliche Erlaubnis weder auszugsweise noch vollständig genutzt werden.

13. Erfüllungsort / Gerichtsstand

Erfüllungsort ist der Hauptsitz unseres Unternehmens in Fürthen 57539. Gerichtsstand ist Altenkirchen Westerwald.

14. Anwendbares Recht

Es gilt ausschließlich deutsches Recht unter Ausschluss des UN-Kaufrechts, soweit dies zulässig ist.

15. Credits Guthaben

Credits-Guthaben können weder in Bargeld umgetauscht noch auf andere Accounts übertragen werden.

16. Salvatorische Klausel

Sollten einzelne Bestimmungen unwirksam sein oder werden, bleibt die Wirksamkeit aller anderen Bestimmungen unberührt. Die Parteien verpflichten sich, eine Bestimmung zu vereinbaren, die der unwirksamen Bestimmung wirtschaftlich am nächsten kommt.`
  ),
  section(
    'Widerrufsbelehrung',
    `Da es sich bei den Produkten um digitale Güter ohne Kopierschutz handelt, ist ein Widerruf ausgeschlossen.

Widerrufsrecht

Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (Tuning Files X, Inhaber: Dmytro Bilichenko, Schulstraße 15, 57539 Fürthen, Deutschland, E-Mail: tuningfilesx@gmail.com, Telefon: +49 160 930 48 497) mittels einer eindeutigen Erklärung (z.B. ein per Post versandter Brief, Telefax oder E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können dafür das beigefügte Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist. Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.

Folgen des Widerrufs

Das Widerrufsrecht erlischt bei einem Vertrag über die Lieferung von nicht auf einem körperlichen Datenträger befindlichen digitalen Inhalten auch dann, wenn wir mit der Ausführung des Vertrags begonnen haben, nachdem Sie ausdrücklich zugestimmt haben, dass wir mit der Ausführung des Vertrags vor Ablauf der Widerrufsfrist beginnen, und Ihre Kenntnis davon bestätigt haben, dass Sie durch Ihre Zustimmung mit Beginn der Ausführung des Vertrags Ihr Widerrufsrecht verlieren.

Muster-Widerrufsformular

(Wenn Sie den Vertrag widerrufen möchten, füllen Sie bitte dieses Formular aus und senden Sie es zurück.)

An Tuning Files X, Schulstraße 15, 57539 Fürthen, Deutschland, E-Mail: tuningfilesx@gmail.com

Hiermit widerrufe(n) ich/wir den von mir/uns abgeschlossenen Vertrag über den Kauf der folgenden Waren/die Erbringung der folgenden Dienstleistung. Bestellt am / erhalten am. Name des/der Verbraucher(s). Anschrift des/der Verbraucher(s). Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier). Datum.

Besondere Hinweise: Siehe Allgemeine Geschäftsbedingungen (AGB).`
  ),
];

export const RU: InfoSection[] = [
  section(
    'Условия использования Chip Tuning LLC',
    `Настоящие условия и положения («Условия») регулируют использование нашего веб-сайта и услуг, доступных на веб-сайте. Получая доступ к веб-сайту и используя его, вы принимаете и соглашаетесь соблюдать настоящие Условия. Если вы не согласны с настоящими Условиями, пожалуйста, не используйте наши услуги и не заходите на наш веб-сайт.

Использование сайта

Компания Chip Tuning LLC предоставляет вам ограниченную, неисключительную, непередаваемую и отзываемую лицензию на использование сайта строго в соответствии с настоящими Условиями.

Вы соглашаетесь не использовать сайт таким образом, чтобы:

Нарушает любой национальный, региональный или международный закон или нормативный акт.
Нарушает права интеллектуальной собственности компании Chip Tuning LLC или любой третьей стороны.
Является вредным, мошенническим, обманчивым, угрожающим, оскорбительным, клеветническим, непристойным или иным образом неприемлемым.

Права интеллектуальной собственности

Весь контент на этом веб-сайте, включая текст, графику, логотипы, изображения, а также их подборку и любое программное обеспечение, используемое на сайте, является собственностью Chip Tuning LLC или ее поставщиков и защищен авторским правом и другими законами об интеллектуальной собственности.

Вы соглашаетесь не изменять, не публиковать, не передавать, не продавать, не создавать производные произведения и не использовать в коммерческих целях какой-либо контент целиком или частично, а также соблюдать все уведомления об авторских правах и правах собственности.

Вклад пользователей

Веб-сайт может содержать интерактивные функции, такие как доски объявлений, чаты, профили, форумы и другие сервисы («Интерактивные сервисы»), которые позволяют пользователям размещать или передавать контент («Вклад пользователей»).

Все пользовательские материалы должны соответствовать стандартам контента, изложенным в настоящих Условиях.

Отказ от гарантий

Данный сайт и его содержимое предоставляются «как есть» и «по мере доступности».

Компания Chip Tuning LLC не предоставляет никаких гарантий, явных или подразумеваемых, и отказывается от всех гарантий, включая, помимо прочего:

Торговая привлекательность
Пригодность для конкретной цели
Ненарушение прав интеллектуальной собственности или иных прав.

Ограничение ответственности

Ни при каких обстоятельствах компания Chip Tuning LLC или ее поставщики не несут ответственности за любые убытки, включая, помимо прочего, потерю данных, упущенную выгоду или перерыв в работе бизнеса, возникшие в результате использования или невозможности использования веб-сайта или его материалов, даже если было известно о возможности таких убытков.

Возмещение убытков

Вы соглашаетесь возместить убытки, защитить и оградить компанию Chip Tuning LLC, ее должностных лиц, директоров, сотрудников, агентов и третьих лиц от любых претензий, потерь, обязательств, затрат или расходов (включая разумные гонорары адвокатов), возникающих в результате:

Ваше использование или неправомерное использование сайта или услуг
Пользовательский контент, размещенный вами
Нарушения настоящих Условий
Нарушения применимых законов или прав третьих лиц.

Изменения условий

Компания Chip Tuning LLC оставляет за собой право вносить изменения в настоящие Условия в любое время. Самая актуальная версия заменяет все предыдущие версии. Пользователям рекомендуется периодически просматривать Условия.

Связаться с нами

Компания Chip Tuning LLC Automotive Solutions будет рада ответить на ваши вопросы или комментарии относительно данных Условий:

tuningfilesx.ecu@gmail.com

Получая доступ к нашему веб-сайту и используя его, вы подтверждаете, что прочитали, поняли и согласны соблюдать настоящие Условия.`
  ),
  section(
    'Соглашение об использовании и отказ от ответственности',
    `1. Сфера действия соглашения

Настоящее соглашение распространяется на все файлы для настройки, модификации программного обеспечения и услуги, предоставляемые компанией Chip Tuning LLC, независимо от способа доставки: по электронной почте, путем загрузки, через USB-накопитель или через наш клиентский портал.

2. Использование на свой страх и риск.

Все товары, программное обеспечение и услуги используются покупателем на свой страх и риск.
Компания Chip Tuning LLC не несет ответственности за технические, экономические или иные последствия использования.

3. Ответственность клиента

Клиент несет единоличную ответственность за:

Правильное использование программного обеспечения и файлов настройки.
Соблюдение всех применимых местных, национальных и международных законов.
Любые последствия, связанные с выбросами, диагностикой или одобрением транспортного средства.
Правовые и технические последствия использования в общественном транспорте или в нарушение настоящего соглашения.

Компания Chip Tuning LLC не несет ответственности за неправильное использование, некорректное применение или несанкционированное использование.

4. Полная ответственность за соблюдение законодательства.

Покупатель несет полную ответственность за соблюдение всех правил дорожного движения и норм, касающихся транспортных средств.
Продукция может использоваться только в законно разрешенных целях.

5. Отказ от ответственности

Компания Chip Tuning LLC не несет ответственности за:

Утрата регистрации транспортного средства или сертификата соответствия.
Технические неисправности или повреждения двигателя, вызванные неправильной эксплуатацией.
Штрафы, пени или юридические последствия в связи с несоблюдением требований.
Использование файлов третьими лицами, помимо первоначального клиента.
Для достижения любых технических характеристик

6. Политика отсутствия возврата средств

Приобретая, загружая или получая любой файл, клиент подтверждает полное понимание и принятие данных условий.

Все сборы взимаются за работу и квалификацию наших инженеров, а не за гарантированный результат. Вся выполненная работа должна быть оплачена в полном объеме. Возврат средств, частичный или полный, ни при каких обстоятельствах не производится.

Если выбранный вариант настройки не может быть выполнен, соответствующий баланс будет возвращен на счет клиента только для дальнейшего использования. Возврат средств на внешние платежные системы не допускается.

В случае с неподдерживаемыми транспортными средствами решение проблемы не гарантируется. Если внесение изменений невозможно, услуга будет отменена, а средства возвращены на счет клиента.

Система заявок в службу поддержки предназначена исключительно для решения вопросов, связанных с файлами и услугами, предоставляемыми компанией Chip Tuning LLC. Мы не обязаны бесплатно изменять или исправлять файлы третьих лиц.

Благодарим за понимание.`
  ),
];

export const EN: InfoSection[] = [
  section(
    'Terms of Use for Chip Tuning LLC',
    `The following terms and conditions (the "Terms") govern all use of our website and the services available on the website. By accessing and using the website, you accept and agree to be bound by these Terms. If you do not agree to these Terms, please do not use our services or access our website.

Use of the Site

Chip Tuning LLC grants you a limited, non-exclusive, non-transferable, and revocable license to use the site strictly in accordance with these Terms.

You agree not to use the site in a manner that:

Violates any national, regional, or international law or regulation
Infringes on the intellectual property rights of Chip Tuning LLC or any third party
Is harmful, fraudulent, deceptive, threatening, harassing, defamatory, obscene, or otherwise objectionable

Intellectual Property Rights

All content on this website, including text, graphics, logos, images, as well as the compilation thereof, and any software used on the site, is the property of Chip Tuning LLC or its suppliers and is protected by copyright and other intellectual property laws.

You agree not to modify, publish, transmit, sell, create derivative works from, or exploit any content in whole or in part and to comply with all copyright and proprietary notices.

User Contributions

The website may contain interactive features such as message boards, chat rooms, profiles, forums, and other services ("Interactive Services") that allow users to post or transmit content ("User Contributions").

All User Contributions must comply with the Content Standards set out in these Terms.

Disclaimer of Warranties

The site and its content are provided on an "as is" and "as available" basis.

Chip Tuning LLC makes no warranties, express or implied, and disclaims all warranties including, but not limited to:

Merchantability
Fitness for a particular purpose
Non-infringement of intellectual property or other rights

Limitation of Liability

In no event shall Chip Tuning LLC or its suppliers be liable for any damages, including but not limited to loss of data, loss of profit, or business interruption, arising from the use or inability to use the website or its materials, even if advised of the possibility of such damages.

Indemnification

You agree to indemnify, defend, and hold harmless Chip Tuning LLC, its officers, directors, employees, agents, and third parties from any claims, losses, liabilities, costs, or expenses (including reasonable attorney's fees) arising from:

Your use or misuse of the site or services
User content posted by you
Violations of these Terms
Violations of applicable laws or third-party rights

Modifications to Terms

Chip Tuning LLC reserves the right to change these Terms at any time. The most current version will supersede all previous versions. Users are encouraged to review the Terms periodically.

Contact Us

Chip Tuning LLC Automotive Solutions welcomes your questions or comments regarding these Terms:

tuningfilesx.ecu@gmail.com

By accessing and using our website, you acknowledge that you have read, understood, and agree to be bound by these Terms.`
  ),
  section(
    'Usage Agreement & Liability Disclaimer',
    `1. Scope of Agreement

This agreement applies to all tuning files, software modifications, and services provided by Chip Tuning LLC, whether delivered via email, download, USB, or through our client portal.

2. Use at Your Own Risk

All products, software, and services are used at the buyer's own risk.
Chip Tuning LLC accepts no liability for technical, economic, or other consequences of use.

3. Customer Responsibility

The customer is solely responsible for:

Proper use of the software and tuning files
Compliance with all applicable local, national, and international laws
Any consequences related to emissions, diagnostics, or vehicle approval
Legal and technical outcomes if used in public traffic or contrary to this agreement

Chip Tuning LLC accepts no liability for misuse, incorrect application, or unauthorized use.

4. Sole Responsibility for Legal Compliance

The buyer is fully responsible for compliance with all vehicle and traffic laws.
Products may only be used for legally permissible purposes.

5. Liability Waiver

Chip Tuning LLC assumes no responsibility for:

Loss of vehicle registration or type approval
Technical defects or engine damage caused by incorrect use
Fines, penalties, or legal consequences due to non-compliant use
Use of files by third parties beyond the original customer
For achieving any performance specifications

6. No Refund Policy

By purchasing, downloading, or receiving any file, the customer confirms full understanding and acceptance of these terms.

All fees are charged for the labor and expertise of our engineers, not for guaranteed results. All completed work must be fully compensated. No refunds, partial or full, will be issued under any circumstances.

If a selected tuning option cannot be completed, the corresponding credit will be returned to the client's account for future use only. Refunds to external payment methods are not permitted.

For unsupported vehicles, no guarantee of a solution is provided. If modification is impossible, the service will be canceled and the credit returned to the client account.

The support ticket system is intended solely for issues related to files and services provided by Chip Tuning LLC. We are not obligated to modify or correct third-party files free of charge.

Thank you for your understanding.`
  ),
];
